import React from "react";
import styled from "styled-components";
import { Column, Text } from "../theme/index";
import ReactMarkdown from "react-markdown";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #1c334f;
  justify-content: center;
  background: #fff;
  grid-area: c;
  transition: 1s;
  @media (max-width: 1100px) {
    flex-direction: column;
    height: 100%;
    text-align: center;
    width: 100%;
  }
`;

const StyledColumn = styled(Column)`
  align-items: center;
  text-align: center;
  width: 90%;
  transition: 1s;
  @media (max-width: 1100px) {
    margin: 0;
    width: 95%;
  }
`;

const Div = styled.div`
  border: 1px solid #ffaf77;
  height: 0.5px;
  width: 40%;
  background-color: #ffaf77;
  margin: 0 auto 1em auto;
`;

export default function Content({ learnMore, handleClick, isOpen }) {
  // let preview = markdown && markdown.slice(0, 100);

  return (
    <Wrapper>
      <StyledColumn>
        <Text protitle>Learn More</Text>
        <Div />
        <Column margin="1em 0 1.5em 0">
          <ReactMarkdown source={learnMore} escapeHtml={false} />
        </Column>
        {/* <Button home onClick={handleClick}>
          {isOpen ? "Read less" : "Read more"}
        </Button> */}
      </StyledColumn>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/Content.jsx